import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { ASSETS } from "../lib/assets";

export const StorySection = () => {
  const { t } = useI18n();
  return (
    <section
      id="story"
      data-testid="story-section"
      className="relative max-w-7xl mx-auto px-4 sm:px-6 py-20 md:py-28"
    >
      <div className="grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-4 relative">
          <div className="terminal-frame p-5">
            <div className="font-pixel text-[#ff0044] glow-pink text-lg tracking-widest">// {t.story.targetTitle}</div>
            <div className="mt-4 relative aspect-square rounded-sm overflow-hidden bg-black">
              <img
                data-testid="story-skull-image"
                src={ASSETS.skull}
                alt="Level Boss — enemy"
                className="pixelated w-full h-full object-contain"
              />
              <div className="absolute inset-0 pointer-events-none" style={{
                backgroundImage: "linear-gradient(rgba(255,0,68,0.06) 50%, transparent 50%)",
                backgroundSize: "100% 3px",
              }} />
            </div>
            <div className="mt-4 font-mono text-xs text-[#94a3b8] space-y-1">
              <div>{t.story.targetIdLabel}........: <span className="text-[#ff0044]">{t.story.targetId}</span></div>
              <div>{t.story.targetAliasLabel}.....: <span className="text-[#ffe600]">{t.story.targetAlias}</span></div>
              <div>{t.story.targetThreatLabel}....: <span className="text-[#ff0044]">▮▮▮▮▮▮▮▮ {t.story.targetThreat}</span></div>
              <div>{t.story.targetStatusLabel}....: <span className="text-[#2bff88]">{t.story.targetStatus}</span></div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-8">
          <div className="section-tag">{t.story.year}</div>
          <h2 className="font-pixel text-[#00ffff] glow-cyan text-4xl sm:text-6xl mt-2 tracking-widest">
            {t.story.title}
          </h2>
          <div className="mt-8 space-y-5 font-mono text-[#e2e8f0]/85 text-base sm:text-lg leading-relaxed">
            {t.story.paragraphs.map((p, i) => (
              <p key={i}>
                {i === 0 && <span className="text-[#ff0044] glow-pink mr-2">▮</span>}
                {p}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StorySection;
